 import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import { FormContext } from '../Component/Forms/FormContext';
import Element from './Element';
import ThemeControls from '../Component/AllThemesControl';
import { FormJSONCreateContext } from '../Component/FormJSONCreateContext';
import { PreviewSharp } from '@mui/icons-material';
import {APIDEL} from '../services/APIServices';

const generateUniqueId = () => {
    return Math.random().toString(36).substring(1);
};

function NestedRender({ id, setDataObj, formJSON, keyProp, field_value, handleChangeDataMarge, field_disabled_Edit, field_temp_value,field_option_src}) {
    const { useStyle } = ThemeControls;
    const classes = useStyle();
    const { handleChange: handleChangeParent } = useContext(FormContext);
    const { contextJson } = useContext(FormJSONCreateContext);
    const [tableRows, setTableRows] = useState([]);
    const [elements, setElements] = useState(formJSON);
    const [dealStatus, setDealStatus] = useState(field_disabled_Edit);

    const forceUpdate = useCallback((args) => setElements(args), []);
    const { fields } = elements;

    useEffect(() => {
        if (Array.isArray(field_value)&&field_value&&field_value.length>0){
            setTableRows(field_value);
            const tempData = [...field_value];
            tempData?.forEach(fields => {
                fields?.map((thisField)=>{
                  if (thisField.field_runtime_ops) {
                    thisField.field_runtime_ops.forEach(field => {
                      if (field.condition)
                        var resultEval;
                        var stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
                        eval(stmt);
                         
                        if (resultEval) {
                             
                            eval(field.ops);
                            setTableRows(tempData);
                        }
                    });
                  }
                })
              })
              
        }
    }, [field_value]);

    useEffect(() => {
        console.log("field_temp_value changed:", field_temp_value);
        setDealStatus(field_disabled_Edit)
        // forceUpdate(formJSON)
        setTableRows(prevData =>
            prevData.map(array =>
                array.map(field => {
                        const field_id = field.field_id.split('.')[0];
                        const stableFieldId = field_id + generateUniqueId();
                        return {
                            ...field,
                            field_id: stableFieldId,
                            field_disabled: (field_disabled_Edit == 3 || field_disabled_Edit == 5) ? true:!field.field_disabled&&field_disabled_Edit == 2 ? false : field.field_disabled,
                            field_value: (field_temp_value[field_id] !== undefined&&array[2].field_value=='1') ? field_temp_value[field_id] : field.field_value,
                            // field_type: field_disabled_Edit == 3&&!(field.field_display_close)? 'hidden':(field_disabled_Edit == 3 || field_disabled_Edit == 5)&&field.field_display_close&&field.field_type!=='hidden'&&field.field_disabled_Edit!=='edit'?'readOnly':field_disabled_Edit == 2&&!(field.field_display_star)? 'hidden' : field.field_type,
                            field_option_src: {
                                ...field.field_option_src,
                                field_option_src_critieria: (field.field_option_src && field_id === "techprefix" && field_option_src[keyProp] !== undefined) ? field_option_src[keyProp] : (field.field_option_src ? field.field_option_src.field_option_src_critieria : undefined)
                            }
                        };
                    
                })
            )
        );

    // Trigger handleChangeDataMarge with updated rows
    setTableRows(updatedRows => {
        handleChangeDataMarge(updatedRows, keyProp);
        return updatedRows; // Ensures the state gets updated with the correct value
    });

    }, [field_temp_value, field_option_src,field_disabled_Edit]);


    const handleChange = (_id, event, valueStr) => {
        const updatedRows = [...tableRows];
        updatedRows.forEach((row) => {
            row.forEach((field) => {
                if (field.field_id === _id) {
                    field.field_value = valueStr;
                }
            });
        });
        const tempData = [...tableRows];
        tempData?.forEach(fields => {
            fields?.map((thisField)=>{
              if (thisField.field_runtime_ops) {
                thisField.field_runtime_ops.forEach(field => {
                  if (field.condition)
                    var resultEval;
  
                  var stmt = "resultEval = thisField." + field.condition.field + " " + field.condition.operator + " \"" + field.condition.checkVal + "\""
  
                  eval(stmt);
                   
                   
                   
                  if (resultEval) {
                     
                    eval(field.ops);
                    setTimeout(forceUpdate(formJSON), 0);
                    setTableRows(tempData);
                  }
                });
              }
            })
          })

        setTableRows(updatedRows);
        handleChangeDataMarge(updatedRows, keyProp)     
    };
    const newRows = tableRows.concat([
        fields.map((field) => ({
            ...field,
            field_id: field.field_id + generateUniqueId(),
            field_value: (field_temp_value[field.field_id] !== undefined) ? field_temp_value[field.field_id] : field.field_default_value ? field.field_default_value : (field.field_type === "hidden" ? field.field_value : ""),
            field_label: "",
            field_disabled: (field_disabled_Edit == 3 || field_disabled_Edit == 5) ? true:!field.field_disabled&&field_disabled_Edit == 2 ? false : field.field_disabled,
            // field_type: field_disabled_Edit == 3&&!(field.field_display_close)? 'hidden':(field_disabled_Edit == 3 || field_disabled_Edit == 5)&&field.field_display_close&&field.field_type!=='hidden'&&field.field_disabled_Edit!=='edit'?'readOnly':field_disabled_Edit == 2&&!(field.field_display_star)? 'hidden' : field.field_type,
            field_option_src: {
                ...field.field_option_src,
                field_option_src_critieria: (field.field_option_src && field.field_id === "techprefix" && field_option_src[keyProp] !== undefined) ? field_option_src[keyProp] : (field.field_option_src ? field.field_option_src.field_option_src_critieria : undefined)
            }
        }))
    ]);

    useEffect(()=>{
        if(!id){
            setTableRows(newRows);
            // handleChangeDataMarge(newRows, keyProp)
        }
    },[])

    const addRow = () => {
        setTableRows(newRows);
    };

    const removeRow = (index) => {
        // setTableRows((prevRows) => prevRows.filter((_, i) => i !== index));
        setTableRows((prevRows) => {
            const updatedRows = prevRows.filter((_, i) => i !== index);
            const removeData = prevRows.filter((_, i) => i === index);
            if(id){
                removeData[0].forEach((item)=>{
                    const  fieldID = item?.field_id.split('.')[0]
                    if(fieldID==="dealdetailid"){
                     if(item.field_value){
                        deletingData(item.field_value)
                     }else{
                        console.log('no id')
                     }
                    }
                     })
            }
            handleChangeDataMarge(updatedRows, keyProp);
            return updatedRows;
        });
    };

    function renderSuccessPage(props){
        if(props?.dataRecevied?.statusCode==="Success"){
            alert('Successfully deleted')
        }
      }

    async function deletingData(id) {
        let data = {};
        let confirmDialog = window.confirm('Are you sure you want to Delete Deal Details?')
        if(confirmDialog){
        try {
          const response = await APIDEL('deal/ds/gtsDealdetail' + '/' + id, data, formJSON, renderSuccessPage);
          if (response) {
            return response;
          }
        } catch (error) {
          console.error(error);
          throw error;
        }
    }
      }
    const handleTotal = (key) => {
        let sum = 0;
        if (tableRows) {
            tableRows.forEach((fields) => {
                fields.forEach((item) => {
                    const itemId = item.field_id.split('.')[0];
                    if (itemId === key) {
                        sum += parseFloat(item.field_value) || 0;
                    }
                })
            })
        }
        return sum.toFixed(2);
    };
////console.log(tableRows)
////console.log(field_disabled_Edit)
////console.log(formJSON)
    return (
        <>
            <FormContext.Provider value={{ handleChange }}>
                <div className={classes.breakForm}>
                    <div className={classes.subtable}>
                        <div className={classes.btnHeader}>
                            <h1>{formJSON.page_heading_label ? formJSON.page_heading_label : ''}</h1>
                            {dealStatus!=3?<button className={classes.subBtn} onClick={addRow}>
                                Add Row
                            </button>:<></>}
                        </div>
                        <div style={{ overflow: 'auto' }}>
                            <table>
                                <thead>
                                    <tr>
                                        {/* {formJSON.fields.map((field) => (
                                            field.field_type !== "hidden"&&field_disabled_Edit === 3&&field.field_display_close?<th key={field.field_id}>{String(field.field_label)}</th>:
                                            field.field_type !== "hidden"&&field_disabled_Edit === 2&&field.field_display_star?<th key={field.field_id}>{String(field.field_label)}</th>:null
                                        ))} */}
                                        {elements.fields.map((field) => {
                                            if (field.field_type !== "hidden") {
                                                    return <th key={field.field_id}>{field.field_label}</th>;
                                            }
                                        })}

                                        {dealStatus!=3&&<th>Action</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableRows.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {row.map((field, fieldIndex) => (
                                                field.field_type !== "hidden"&&(field.field_type!=='readOnly' ? <td key={field.field_id}>
                                                    <Element key={rowIndex} field={field} />
                                                </td>:<td>{field.field_value}</td>)
                                            ))}
                                             {dealStatus!=3&&<td>
                                                <button
                                                    onClick={() => removeRow(rowIndex)}
                                                    // disabled={tableRows.length === 1}
                                                >
                                                    Remove
                                                </button>
                                            </td>}
                                        </tr>
                                    ))}
                                    <tr className="noBorder">
                                        {/* {formJSON.fields.map((field) => (
                                            field.field_type !== "hidden" && <td key={field.field_id}> {field.field_Sum === 'yes' && handleTotal(field.field_id)}</td>
                                        ))} */}
                                          {elements.fields.map((field) => {
                                            if (field.field_type !== "hidden") {
                                                    return  <td key={field.field_id}> {field.field_Sum === 'yes' && handleTotal(field.field_id)}</td>;
                                            }
                                        })}
                                        {dealStatus!=3&&<td>Sum</td>}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </FormContext.Provider>
        </>
    );
}

function NestedAddRowRender(props) {
    const { useStyle } = ThemeControls;
    const classes = useStyle();
    const { id, field_context, field_id, field_value, field_disabled_Edit, field_temp_value, field_option_src } = props;
    const { handleChange: handleChangeParent } = useContext(FormContext);
    const contextJson = field_context;
    const [mergedData, setMergedData] = useState({});
    const [allData,setAlldata] = useState(field_value || []);
    const [values, setValues] = useState({ Parameter: [], Parameter_1: [] });
    let data={}
    useEffect(()=>{
        if(field_value){
            Object.keys(contextJson).map((key, index) => {
                const filteredData = filterFieldValue(key, field_value);
                ////console.log(filteredData)
                setValues(prevValues => ({
                  ...prevValues,
                  [key]: filteredData,
                }));
            })
        }
    },[])

//console.log(field_value)
//console.log(field_disabled_Edit)
    const handleChangeDataMerge = useCallback((updatedRows, keyProp) => {
        ////console.log(updatedRows)
        setValues((prevValues) => ({
            ...prevValues,
            [keyProp]: updatedRows,
          }));
    },[]);
    
    // //console.log(field_value)
    //console.log(values)
      const filterFieldValue = (key, field_value) => {
        if (key === 'Parameter' && id) {
          const GtsToCarrier = field_value?.filter(obj => obj.trafficstatus === 1);
          const tempData = generateTempData(GtsToCarrier, contextJson[key], field_disabled_Edit, key);
          return tempData;
        } else if(key === 'Parameter_1' && id){
          const CarrierToGts = field_value?.filter(obj => obj.trafficstatus === 2);
          const tempData = generateTempData(CarrierToGts, contextJson[key], field_disabled_Edit, key);
          return tempData;
        }else{
            return []
        }
      };

      const generateTempData = (field_value, formJSON, field_disabled_Edit, keyProp) => {
        if (Array.isArray(field_value) && field_value.length > 0) {
          const tempData = field_value.map((row) => {
            const uqId = generateUniqueId();
            let temp_value = [];
            const updateRow = formJSON.fields.map((field) => {
              let fieldValue = row[field.field_id];
              if (field.field_id === "techprefix" && row['gtsDealtechprefix'] && row['trafficstatus']==1) {
                let temp = row['gtsDealtechprefix'].map(item => item.techprefix === "" ? " " : item.techprefix);
                temp_value = row['gtsDealtechprefix'];
                console.log(temp_value)
                fieldValue = temp.join(', ');
              }else if (field.field_id === "techprefix" && row['gtsDealtechprefix'] && row['trafficstatus']==2){
                temp_value=[]
              }
              if (field.field_id === "breakoutname" && row['gtsDealbreakout']) {
                let temp = row['gtsDealbreakout'].map(item => item.breakout);
                temp_value = row['gtsDealbreakout'];
                fieldValue = temp.join(', ');
              }
              console.log(fieldValue)
              return {
                ...field,
                field_id: field.field_id + uqId,
                field_value: fieldValue,
                // field_value: (field_temp_value[field.field_id] !== undefined) ? field_temp_value[field.field_id] : field.field_value,
                field_temp_bucket: temp_value,
                field_label: "",
                // field_disabled_Edit: field_disabled_Edit,
                field_disabled: (field_disabled_Edit == 3 || field_disabled_Edit == 5) ? true:!field.field_disabled&&field_disabled_Edit == 2 ? false : field.field_disabled,
                  field_option_src: {
                      ...field.field_option_src,
                      field_option_src_critieria: (field.field_option_src && field.field_id === "techprefix" && field_option_src[keyProp] !== undefined) ? field_option_src[keyProp] : (field.field_option_src ? field.field_option_src.field_option_src_critieria : undefined)
                  }
              };
            });
            //console.log(updateRow)
            return updateRow;
          });
      
          return tempData;
        } else {
          return [];
        }
      };
       
      useEffect(() => {
        if(values.Parameter.length>0 || values.Parameter_1.length>0){
            let mergedArrays = [];
        for (const key in values) {
            if (values.hasOwnProperty(key)) {
                mergedArrays = [...mergedArrays, ...values[key]];
            }
        }
       
            handleChangeParent(field_id, {}, mergedArrays);
        }
      }, [values]);

    const handleTotal = (rowData, key) => {
        let sum = 0;
        if (rowData&&rowData.length>0 ) {
          rowData.forEach((item, rowIndex) => {
                sum += parseFloat(item[key]) || 0;
              })
        }
        return sum.toFixed(2);
      };

    const renderNested = Object.keys(contextJson).map((key, index) => {
        if (key !== "xioFEConfig") {
            return (
                <NestedRender
                    key={index}
                    id={id}
                    setDataObj={setMergedData}
                    formJSON={contextJson[key]}
                    keyProp={key}
                    field_value={values[key]}
                    handleChangeDataMarge={handleChangeDataMerge}
                    field_disabled_Edit={field_disabled_Edit}
                    field_temp_value={field_temp_value}
                    field_option_src={field_option_src}
                />
            );
        }
        return null;
    });

    const additionalElements = (
        <div className={classes.breakForm}>
            <div className={classes.subtable}>
            <div style={{ overflow: 'auto' }}>
                <table className='mb'>
                    <thead>
                        <tr>
                            {contextJson['Parameter'].fields.map((field, colIndex) => {
                                // field.field_type !== "hidden" && 
                                // <th key={colIndex}>
                                //     {field.field_label}
                                // </th>
                                 if (field.field_type !== "hidden") {
                                        return  <th key={colIndex}>{field.field_label}</th>;
                                }
                              })}
                        </tr>
                    </thead>
                    <tbody>
                        <tr className='noBorder'>
                            {contextJson['Parameter'].fields.map((field, colIndex) => {
                                // field.field_type !== "hidden" && 
                                // <td key={colIndex}>
                                //     {field.field_Sum === "yes" && handleTotal(allData, field.field_id)}
                                // </td>
                                if (field.field_type !== "hidden") {
                                        return  <td key={colIndex}>{field.field_Sum === "yes" && handleTotal(allData, field.field_id)}</td>;
                                }
                          })}
                        </tr>
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    );
    

    return (
        <>
        {renderNested}
        {additionalElements}
        </>
    );
}

export default NestedAddRowRender;

